function deriveFromProfile(profile = {}) {
  const issues = Array.isArray(profile.issues) ? profile.issues : [];
  const disabledReason = String(profile.disabledReason || '');
  const chargesEnabled = Boolean(profile.chargesEnabled);
  const payoutsEnabled = Boolean(profile.payoutsEnabled);
  const accountId = String(profile.accountId || '').trim();
  const canCharge = Boolean(profile.canCharge ?? (accountId && chargesEnabled));
  const canPayout = Boolean(profile.canPayout ?? (accountId && payoutsEnabled));

  const ready = Boolean(
    accountId
    && canCharge
    && canPayout
    && !disabledReason
    && issues.length === 0
  );

  const statusPhase = !accountId
    ? 'not_connected'
    : !canCharge
      ? 'setup_required'
      : !canPayout
        ? 'charge_enabled'
        : 'fully_enabled';

  return {
    ready,
    statusPhase,
    canCharge,
    canPayout,
    issues,
    disabledReason,
    chargesEnabled,
    payoutsEnabled,
    accountId,
    country: profile.country || '',
    provider: profile.provider || 'stripe',
    type: profile.accountType || profile.type || 'express',
  };
}

export function deriveActiveConnectStatus(user) {
  return deriveFromProfile(user?.connect || {});
}

export function deriveConnectStatus(user) {
  return deriveActiveConnectStatus(user);
}
